define(["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.FencingStatusDomain = void 0;
    class FencingStatusDomain {
        static initialise() {
            if (!this.isInitialised) {
                this.isInitialised = true;
                this.values = [
                    { key: FencingStatusDomain.FencedIntoApplicantsProperty, value: "Fenced into applicant’s property" },
                    { key: FencingStatusDomain.NotFencedIntoApplicantsProperty, value: "Not fenced into applicant’s property" }
                ];
                this.KeyIndex = {};
                this.KeyIndex[FencingStatusDomain.FencedIntoApplicantsProperty] = 0;
                this.KeyIndex[FencingStatusDomain.NotFencedIntoApplicantsProperty] = 1;
                this.ValueIndex = {};
                this.ValueIndex["Fenced into applicant’s property"] = 0;
                this.ValueIndex["Not fenced into applicant’s property"] = 1;
            }
        }
        static get Values() {
            this.initialise();
            return this.values;
        }
        static findByValue(value) {
            this.initialise();
            if (this.ValueIndex[value] != null) {
                return this.Values[this.ValueIndex[value]];
            }
            return null;
        }
        static findByKey(key) {
            this.initialise();
            if (this.KeyIndex[key] != null) {
                return this.Values[this.KeyIndex[key]];
            }
            return null;
        }
    }
    exports.FencingStatusDomain = FencingStatusDomain;
    Object.defineProperty(FencingStatusDomain, "FencedIntoApplicantsProperty", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "F"
    });
    Object.defineProperty(FencingStatusDomain, "NotFencedIntoApplicantsProperty", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "N"
    });
    Object.defineProperty(FencingStatusDomain, "isInitialised", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
});
